import { AppBar, Container, styled } from '@mui/material';

export const HeaderWrapper = styled(AppBar)(() => ({
    background: 'inherit',
    boxShadow: 'none',
    height: '82px',
}));

export const HeaderContainer = styled(Container)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'inherit',
    alignItems: 'center',
    height: '100%',
}));
